import React, { useState, useRef, useEffect } from "react";
import LoginImg from '../../images/login1.png'
import { FiX } from "react-icons/fi";
export default function CandidateSignIn(props) { 
  return (
    props.showLoginPopup && (
   <div className="login_popup">
    <div className="login_inner_popup">
    <FiX className="popup_close_div" onClick={()=>props.HideLoginPopup()}/>
        <div className="left_login_inner_popup">
            <div className="login_inner_svg">
                <img src={LoginImg} className="img-fluid" width="100%" height="100%"/>
            </div>
            
        </div>
        <div className="right_login_inner_popup">
            <div className="login_head">Login</div>
            <div className="inner_login_container">
           <div className="login_form">
           <input type="text" className="login_input" placeholder="Email-Id"/>
            <input type="text" className="login_input" placeholder="Password"/>
            <button type="button" className="login_btn">Send</button>
            <div className="py-3"><span className="text-muted" style={{cursor:'pointer'}}>Forgot password?</span></div>
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 me-2 sign-in-form">Don't have an account?</p>
                    <a href="" className="btn btn-outline-primary btn-sm create-new">Create new</a>
                </div>
           </div>
            </div>           
        </div>
    </div>
   </div>
    )
  );
}
